import { render, staticRenderFns } from "./education.vue?vue&type=template&id=6bde1aa3&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"
import style0 from "./education.vue?vue&type=style&index=0&id=6bde1aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde1aa3",
  null
  
)

export default component.exports